<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4 translate>company.dids.reactivate-deleted-did.popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__form">
      <p translate>company.dids.reactivate-deleted-did.popup.subtitle</p>
      <gdp-subscription-change-checkboxes (onEmitFormValue)="checkboxesData = $event">
      </gdp-subscription-change-checkboxes>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary" type="submit" (click)="onSubmit()" [disabled]="!checkboxesData.isValid"
          [ladda]="loading" data-style="zoom-in" data-spinner-color="#fff">
          <span translate>common.activate</span>
        </button>
      </div>
    </div>
  </div>
</div>